/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AppTitle from 'DesignSystem/AppTitle/react'
import AutoSignOutTimeout from './AutoSignOutTimeout/index'
import Body from 'DesignSystem/Body/index'
import KeepSessionOpenAction from './KeepSessionOpenAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import SignOutAction from './SignOutAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/InactivityWarning/Content"
  
}) {
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<AppTitle
  viewPath={`${viewPath}/AppTitle`}
 swap={true}
 text="You'll be logged out"
/>
<Body
  viewPath={`${viewPath}/Body`}
 text="You've been inactive for too long..."
/>
<AutoSignOutTimeout
  viewPath={`${viewPath}/AutoSignOutTimeout`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<KeepSessionOpenAction
  viewPath={`${viewPath}/KeepSessionOpenAction`}
/>
<SignOutAction
  viewPath={`${viewPath}/SignOutAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}